export default {
  workOrder: "Work order number",
  oralReviewCode: "Comment number",
  status: "Status",
  studentLeval: "Srudent rating",
  isAnswered: "Reply status",
  distributionTime: "Allocation time",
  orderTakingTime: "Order taking time",
  timeoutStatus: "Timeout status",
  commentTimeout: "Comment timeout",
  commentNotTimeout: "Comment not timeout",
  commentCompletionTime: "Comment completion time",
  distributionStartTime: "Start allocating time",
  distributionEndTime: "End allocation time",
  publishStartTime: "Start release time",
  publishEndTime: "End release time",
  search: "Search",
  clear: "Clear",
  tobeCorrected: "To do",
  correcting: "Underway",
  toBeAssigned: "To be assigned",
  assign: "assign",
  reAssign: "reAssign",
  reback: "Called back",
  recorrect: "To be revised",
  // comment: "Rated",
  all: "All",
  index: "No.",
  overTime: "Expiry Time",
  service: "Type",
  studentComments: "Student comment",
  answerContent: "answer",
  operation: "Operation",
  detail: "details",
  correctTeacher: "Correct teacher",
  comment: "comment",
  viewComments: "View comments",
  serviceTitle: "Type",
  oralQuestion: "Oral topic",
  userInfo: "User Information",
  topic: "Topic",
  question: "Question",
  userRecoring: "User recording",
  oralScore: "Band Score",
  oralComment: "Mock Test Report",
  pronunciation: "Pronunciation",
  vocabulary: "Lexical resource",
  grammar: "Grammatical range and accuracy",
  fluency: "Fluency and coherence",
  composite: "Overall band score",
  pastScore: "Score History",
  pronunciationTip: "Advice on Prounciation",
  vocabularyTip: " Advice on Lexical resource",
  grammarTip: "Advice on grammatical range and accuracy",
  fluencyTip: "Advice on Fluency and coherence",
  wrongWords:
    "Write down words with incorrect prounciation, separated by a comma",
  wrongWordsRule:
    "Correct the mispronounced words and fill them in one by one, separated by English commas','with no space after the commas. For example: house, exit, ground",
  preparationTips: "Comprehensive Advice ",
  userComments: "User comments",
  firstOrder: "First order",
  serviceTypes: {
    "0": "Quick review",
    "1": "Fine review",
    "2": "Answer Upgrade",
    "3": "Model test score",
    "4": "Add answers",
    "5": "Model Oral Test - Upgrade"
  },
  answerCustom: "Answer customization",
  wrongWordValidTip:
    "The wrong word can only contain words and English commas.",
  completeTip: "Please fill in the report completely.",
  reportCompleteTip:
    "The comment content of the report is empty and cannot be submitted. Please improve the report content",
  wordLimit: "The number of words in the report shall not exceed 10000.",

  lastScore: "Last exam score",
  targetScore: "Target score",
  examDate: "Next exam date",
  points: "points",

  save: "Save",
  handleReback: "Cancel",
  review: "Submit",
  returnReason: "Cancel reason",
  returnReasonRequired: "Cancel reason cannot be blank",
  reasonTip: "Please enter the reason",
  scoreRequiredTip:
    "The score is not filled in the correction report! Please fill in and continue to submit",
  optDesc: "Are you sure you want to {str} the comment report?",
  statusMap: {
    "0": "Underway",
    // "1": "To be modified",
    "1": "Called back",
    "2": "To be reviewed",
    "3": "Submitted",
    "4": "Evaluated",
    "5": "To be revised",
    "6": "Canceled"
  },
  teacherId: "Teacher_id",
  teacherName: "Teacher name",
  workRole: "Role",
  allocation: "Quota",
  priority: "Priority",
  allocateStatus: "Automatic allocation status",
  edit: "Amend",
  stop: "Close",
  effect: "Open",
  delete: "Delete",
  stopTip:
    "After ”Close“, the system will no longer automatically send orders to the teacher!",
  effectTip:
    "After ”Open“, the system will automatically send the order to the teacher!",
  deleteTip: "After “Delete“, automatically send orders to the teacher!",
  ruleForm: {
    role: "Role",
    institution: "Institution",
    teacher: "Teacher",
    quota: "Quota",
    type: "Type",
    priority: "Priority",
    remark: "Remark"
  },
  placeholder: {
    input: "Please input",
    select: "Please select"
  },
  priorityLevel: {
    priority: "Priority",
    hign: "Hign",
    middle: "Middle",
    low: "Low",
    empty: "No priority"
  },
  day: "Day",
  roleOptions: {
    institution: "Institution",
    teacher: "Teacher"
  },
  dialogTitle: {
    add: "Creation order rules",
    update: "Modify the rules",
    tip: "Prompt for action"
  },
  create: "Creation",
  switchText: "Task on-off",
  optSuccess: "Success!",
  quotaCheckTip: "Please fill in a number from 1 to {num}",
  currentReceiveCount: "Orders being processed"
};



// WEBPACK FOOTER //
// ./src/i18n/en-US/oralComment.js